// extracted by mini-css-extract-plugin
export default {"error":"StatusMessages_error__p8+1K"};